shadow$provide[404] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 getGammaOutColor(vec4 rgba) {
  return vec4(sqrt(rgba.rgb), rgba.a);
}
`;

};